import React from 'react';
import { CHECKER_RESULT, RUN_STATUS, TONE_CLASS } from './cbtQuestionRuns.config';

/* Small coloured labels used on both generator pages. */

const pillClass = 'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold';

// A run's status, e.g. "Ready for review"
export function RunStatusPill({ status }) {
  const info = RUN_STATUS[status] || { label: status, tone: 'slate', working: false };

  return (
    <span className={`${pillClass} ${TONE_CLASS[info.tone]}`}>
      {/* A pulsing dot while the cron is still busy with the run */}
      {info.working && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-current" />}
      {info.label}
    </span>
  );
}

// A draft's checker label, e.g. "Checker disagreed". Nothing before the check.
export function CheckerPill({ result }) {
  if (!result) {
    return null;
  }
  const info = CHECKER_RESULT[result] || { label: result, tone: 'slate' };

  return <span className={`${pillClass} ${TONE_CLASS[info.tone]}`}>{info.label}</span>;
}
